import React from "react";
import { IconContext } from "react-icons"; // Optional for consistent icon styling

const SkillCard = ({ icon, label }) => {
  return (
    <div className="skill-card d-flex flex-column align-items-center p-3">
      <IconContext.Provider value={{ size: "2.5em" }}>
        {icon}
      </IconContext.Provider>
      <p className="mt-2">{label}</p>
    </div>
  );
};

export default SkillCard;
